export default "__VITE_ASSET__BjL3D1nF__"